<template>
    <b-form autocomplete="off" id="source_submit" @submit="onSubmit">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <b-form>
                    <b-form-group label="ФИО"
                                  label-for="name">
                        <b-form-input id="name"
                                      size="sm"
                                      type="text"
                                      v-model="user.name">
                        </b-form-input>
                        <span class=" alert-danger"
                              v-if="submitted && !user.name">Поле ФИО является обязательным.</span>
                    </b-form-group>
                    <b-form-group label="Email"
                                  label-for="email">
                        <b-form-input id="email"
                                      size="sm"
                                      type="text"
                                      v-model="user.email">
                        </b-form-input>
                        <span class=" alert-danger"
                              v-if="submitted && !user.email">Поле Email является обязательным.</span>
                        <span class=" alert-danger" v-if="submitted && message">{{message}}</span>
                    </b-form-group>
                    <b-form-group label="Роль"
                                  label-for="role">
                        <b-form-select v-model="user.role"
                                       size="sm"
                                       class="filterComponent">
                            <option value="user">Пользователь</option>
                            <option value="leader">Лидер</option>
                            <option value="admin">Админ</option>
                            <option value="account">Аккаунт</option>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label="Департамент"
                                  label-for="department">
                        <b-form-select v-model="user.department"
                                       size="sm"
                                       class="filterComponent">
                            <option value="agency">Agency</option>
                            <option value="adkey">AdKey</option>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group v-if="user.role == 'leader'" label="Подчинённые"
                                  label-for="users">
                        <v-select :options="availableUsers"
                                  label="name"
                                  required v-model="user.subordinates" multiple>
                            <span slot="no-options">Совпадений не найдено.</span>
                        </v-select>
                    </b-form-group>
                    <div class="row" >
                        <div class="col-sm-6">
                            <b-form-group label="Network ID"
                                          label-for="network_partner_id">
                                <b-form-input id="network_partner_id"
                                              size="sm"
                                              autocomplete="off"
                                              type="number"
                                              v-model="user.network_partner_id">
                                </b-form-input>
                            </b-form-group>
                        </div>
                        <div class="col-sm-6">
                            <b-form-group label="Market ID"
                                          label-for="market_partner_id">
                                <b-form-input id="market_partner_id"
                                              size="sm"
                                              name="market_partner_id"
                                              role="market_partner_id"
                                              autocomplete="off"
                                              type="number"
                                              v-model="user.market_partner_id">
                                </b-form-input>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="row" v-if="user.role == 'account'">
                        <div class="col-sm-6">
                            <b-form-group label="Affise Network API ID"
                                          label-for="network_user_id">
                                <b-form-input id="network_user_id"
                                              size="sm"
                                              autocomplete="off"
                                              type="text"
                                              v-model="user.network_user_id">
                                </b-form-input>
                                <span class=" alert-danger" v-if="submitted && network_user_id_message">{{network_user_id_message}}</span>
                            </b-form-group>
                        </div>
                        <div class="col-sm-6">
                            <b-form-group label="Affise Market API ID"
                                          label-for="market_user_id">
                                <b-form-input id="market_user_id"
                                              size="sm"
                                              name="market_user_id"
                                              role="market_user_id"
                                              autocomplete="off"
                                              type="text"
                                              v-model="user.market_user_id">
                                </b-form-input>
                                <span class=" alert-danger" v-if="submitted && market_user_id_message">{{market_user_id_message}}</span>
                            </b-form-group>
                        </div>
                    </div>
                    <b-form-input style="opacity: 0;max-width: 1px;max-height: 1px;padding: 0!important;"
                                  type="text"></b-form-input>
                    <b-form-group label="Пароль"
                                  label-for="newPassword">
                        <b-form-input id="newPassword"
                                      v-on:blur="validateNewPassword()"
                                      size="sm"
                                      autocomplete="new-password"
                                      type="password"
                                      v-model="newPassword">
                        </b-form-input>
                        <span class=" alert-danger"
                              v-if="newPasswordMessage">{{newPasswordMessage}}</span>
                    </b-form-group>
                    <b-form-input style="opacity: 0;max-width: 1px;max-height: 1px;padding: 0!important;"
                                  type="text">
                    </b-form-input>
                    <b-form-group label="Подтверждение пароля"
                                  label-for="passwordRepeat">
                        <b-form-input id="passwordRepeat"
                                      size="sm"
                                      v-on:blur="validateRepeatPassword()"
                                      autocomplete="new-password"
                                      type="password"
                                      v-model="passwordRepeat">
                        </b-form-input>
                        <span class=" alert-danger"
                              v-if="repeatPasswordMessage">{{repeatPasswordMessage}}</span>
                    </b-form-group>
                    <b-dropdown right variant="primary" split text="Сохранить и выйти"
                                v-on:click="onSubmit($event, true)"
                                class="float-right">
                        <b-dropdown-item v-on:click="onSubmit($event, true)">Сохранить и выйти</b-dropdown-item>
                        <b-dropdown-item v-on:click="onSubmit($event, false)">Сохранить и создать</b-dropdown-item>
                    </b-dropdown>
                    <div class="form-errors"></div>
                </b-form>
            </div>
        </div>
        <div class="form-errors"></div>
    </b-form>
</template>
<script>
    import UsersService from '../../../services/usersDataService'

    export default {
        name: 'CreateUserModal',
        components: {
            UsersService: UsersService
        },
        data() {
            return {
                user: {
                    name: null,
                    email: null,
                    network_partner_id: null,
                    market_partner_id: null,
                    market_user_id: null,
                    network_user_id: null,
                    role: 'user',
                    department: null,
                    subordinates: [],
                    newPassword: null
                },
                availableUsers: [],
                submitted: false,
                message: null,
                network_user_id_message: null,
                market_user_id_message: null,
                newPassword: null,
                passwordRepeat: null,
                newPasswordMessage: null,
                repeatPasswordMessage: null,
                isNewPasswordIncorrect: false,
                isRepeatPasswordIncorrect: false
            }
        },
        methods: {
            onSubmit(evt, close) {
                evt.preventDefault();

                this.submitted = true;

                if (!this.user.name || !this.user.email) {
                    evt.preventDefault();

                    return;
                }

                if (this.isNewPasswordIncorrect || this.isRepeatPasswordIncorrect) {
                    evt.preventDefault();

                    return;
                }

                this.user.newPassword = this.newPassword

                let subordinatesArray = [];

                if (this.user.subordinates && this.user.subordinates.length != 0) {
                    this.user.subordinates.forEach(function (subordinate) {
                        subordinatesArray.push(subordinate.id)
                    });
                } else {
                    subordinatesArray = null
                }

                UsersService.createUser(this.user, subordinatesArray)
                    .then(function (response) {
                        if (response) {
                            if (close && !response.error) {
                                window.location.href = '/users';
                            } else if (!close && !response.error) {
                                this.user = {
                                    name: null,
                                    email: null,
                                    network_partner_id: null,
                                    market_partner_id: null,
                                    market_user_id: null,
                                    network_user_id: null,
                                    role: 'user'
                                }
                                this.submitted = false;
                            } else if (response.error) {
                                switch (response.error) {
                                    case 'email exists':
                                        this.message = 'Данный Email используется другим пользователем.';
                                        break;
                                    case 'invalid email':
                                        this.message = 'Некорректный Email.';
                                        break;
                                    case 'incorrect domain':
                                        this.message = 'Email обязан принадлежать почтовому домену @zorka.mobi.';
                                        break;
                                    case 'network_user_id':
                                        this.network_user_id_message = 'Юзер с таким id существует.';
                                        break;
                                    case 'market_user_id':
                                        this.market_user_id_message = 'Юзер с таким id существует.';
                                        break;
                                    default:
                                        this.message = 'Произошла ошибка.';
                                        break;
                                }
                            }
                        }
                    }.bind(this))
            },
            validateNewPassword() {
                this.isNewPasswordIncorrect = false

                if (this.newPassword && this.newPassword.length < 6) {
                    this.newPasswordMessage = 'Пароль должен содержать не менее 6-ти знаков.';
                    this.isNewPasswordIncorrect = true
                }

                if (!this.newPassword) {
                    this.newPasswordMessage = 'Введите новый пароль.';
                    this.isNewPasswordIncorrect = true
                }
                if (this.newPassword && this.newPassword.length >= 6) {
                    this.newPasswordMessage = null;
                }
            },
            validateRepeatPassword() {
                this.isRepeatPasswordIncorrect = false
                if (!this.passwordRepeat) {
                    this.repeatPasswordMessage = 'Введите подтверждение нового пароля.';
                    this.isRepeatPasswordIncorrect = true
                }

                if (this.newPassword && this.passwordRepeat && this.newPassword !== this.passwordRepeat) {
                    this.repeatPasswordMessage = 'Не совпадает с новым паролем.';
                    this.isRepeatPasswordIncorrect = true
                }

                if (this.newPassword && this.passwordRepeat && this.newPassword === this.passwordRepeat) {
                    this.repeatPasswordMessage = null;
                }
            },
            getAvailableSubordinates() {
                UsersService.getAvailableSubordinates()
                    .then(users => {
                        this.availableUsers = users
                    })
            }
        },
        beforeMount() {
            this.getAvailableSubordinates()
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/views/front/modals/CreateUserModal.vue